export default __webpack_public_path__ + "static/media/wellnesssuites.ea1a7421.jpg";